// Zero imports on purpose - mfPlugins.ts can't safely import packages with module-load side effects.
export const MF_PLUGIN_TELEMETRY_EVENT = 'appshell:mf-plugin-telemetry'

export type MfPluginTelemetryDetail =
  | { kind: 'retry-start'; mfeName: string; url?: string }
  | { kind: 'retry-outcome'; mfeName: string; outcome: 'success' | 'error'; url?: string }
  | { kind: 'load-outcome'; mfeName: string; outcome: 'success' | 'error'; recovered: boolean }
